import { render } from "./message-voice.vue?vue&type=template&id=6c5d4138&ts=true"
import script from "./message-voice.vue?vue&type=script&lang=ts"
export * from "./message-voice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__